import { FC } from "react"
import { AttentionsEdit } from "../../../module/attentions/containers/edit"

export const AttentionsEditPage: FC = () => <AttentionsEdit />
